import CryptoJS from 'crypto-js';

const APP_SECRET = 'my-super-secret-key'; // 你的密钥

// 加密/签名函数
/**
 * 对对象进行加密和签名处理
 * @param {Object} obj - 需要加密和签名的对象
 * @returns {Object} 返回包含加密数据(p)和签名(h)的对象
 */
export const seal = (obj) => {
  // 将对象转换为JSON字符串
  const str = JSON.stringify(obj);
  // 将JSON字符串转换为Base64编码
  const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str));
  // 使用HmacSHA256算法生成签名，并截取前8位作为hash值
  const hash = CryptoJS.HmacSHA256(base64, APP_SECRET).toString().substring(0, 8);
  // 返回包含加密数据(p)和签名(h)的对象
  return { p: base64, h: hash };
};

// 解密/验签函数
/**
 * 解封函数，用于验证并解密传入的查询参数
 * @param {Object} query - 包含加密数据和哈希值的查询对象
 * @returns {Object|null} - 解析后的JSON对象，如果验证失败则返回null
 */
export const unseal = (query) => {
  // 从查询对象中解构出加密数据(p)和哈希值(h)
  const { p, h } = query;
  // 检查是否存在加密数据和哈希值，如果任一不存在则返回null
  if (!p || !h) return null;
  // 使用HMAC-SHA256算法计算加密数据的哈希值，并取前8位作为期望的哈希值
  const expectedHash = CryptoJS.HmacSHA256(p, APP_SECRET).toString().substring(0, 8);
  // 比较传入的哈希值与计算出的期望哈希值，如果不匹配则返回null
  if (h !== expectedHash) return null;
  try {
    // 将Base64编码的字符串解析为UTF-8格式的字符串
    const jsonStr = CryptoJS.enc.Base64.parse(p).toString(CryptoJS.enc.Utf8);
    // 将解析后的JSON字符串转换为JavaScript对象并返回
    return JSON.parse(jsonStr);
  } catch (e) { return null; }
};